// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__214b6","index":"styles_index__3k0AI"};